/**************************************************
 * Nombre:       Tarjeta_Estudia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {PlayCircle} from '@mui/icons-material'

const Tarjeta_Estudia = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: item.color,
                p: 6,
                color: '#fff'
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 7}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: 40, fontWeight: 600, lineHeight: 1.1, height: 80}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 2}}>
                    <Typography
                        sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.4, height: 90}}>{item.descripcion}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                    <IconButton sx={{
                        backgroundColor: '#fff'
                    }}>

                        <PlayCircle/>

                    </IconButton>
                </Grid>


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 5}}
                sx={{ml: -10, mb: -8,mt: -13}}
            >

                <img src={item.img} width={'auto'} height={410}/>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Estudia